<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text class="orangehrm-main-title">
        {{ $t('performance.edit_kpi_sub_categories') }}
      </oxd-text>
      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="2" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="subCategoriesKpi.name"
                :label="$t('general.name')"
                required
                :rules="rules.name"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <kpi-categories-dropdown
                v-model="subCategoriesKpi.categoryName"
                :rules="rules.categoryName"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />
        <br />
        <oxd-form-actions>
          <required-text />
          <oxd-button
            type="button"
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {
  required,
  shouldNotExceedCharLength,
} from '@ohrm/core/util/validation/rules';
import {APIService} from '@/core/util/services/api.service';
import KpiCategoriesDropdown from '@/orangehrmPerformancePlugin/components/KpiCategoriesDropdown.vue';

const initialSubCategoriesKpi = {
  name: '',
  categoryName: null,
};

export default {
  name: 'KpiSubCategoriesEdit',
  components: {
    'kpi-categories-dropdown': KpiCategoriesDropdown,
  },
  props: {
    kpiSubCategoryId: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/performance/kpi-sub-categories',
    );

    return {
      http,
    };
  },
  data() {
    return {
      isLoading: false,
      subCategoriesKpi: {...initialSubCategoriesKpi},
      rules: {
        name: [required, shouldNotExceedCharLength(100)],
        categoryName: [required],
      },
    };
  },
  created() {
    this.isLoading = true;
    this.http
      .get(this.kpiSubCategoryId)
      .then((response) => {
        const {data} = response.data;
        this.subCategoriesKpi.name = data.name;
        this.subCategoriesKpi.categoryName = data.category
          ? {id: data.category.id, label: data.category.name}
          : null;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    onCancel() {
      navigate('/performance/subCategoriesKpi');
    },
    onSave() {
      this.isLoading = true;
      this.http
        .update(this.kpiSubCategoryId, {
          name: this.subCategoriesKpi.name,
          categoryId: this.subCategoriesKpi.categoryName.id,
        })
        .then(() => {
          return this.$toast.saveSuccess();
        })
        .then(() => {
          this.onCancel();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.orangehrm-module-field-row {
  grid-column-start: 1;
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;
}

.orangehrm-module-field-label {
  @include oxd-input-control();
  padding: 0;
  flex-basis: 75%;
}
</style>
